import React from 'react'
import { Link } from '@overdose/components'
import classNames from 'classnames'
import { Image } from '~/components/Image'
import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'
import { getImageSrc } from '~/helpers'
import styles from './MakerHubRelatedArticle.module.css'
import { MakerHubRelatedArticleProps } from './MakerHubRelatedArticle.types'

const MakerHubRelatedArticle = ({
  article,
  className,
}: MakerHubRelatedArticleProps) => {
  const renderDate = (dateString) => {
    const date = new Date(dateString)

    const months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ]

    const day = date.getDate()
    const month = months[date.getMonth()]
    const year = date.getFullYear()
    const maxLength = 2

    return `${day.toString().padStart(maxLength, '0')} ${month} ${year}`
  }

  return (
    <div className={classNames('flex gap-4', className)}>
      <Image
        className={classNames('rounded-md', styles.image)}
        src={getImageSrc(article?.image?.src, '100')}
        addSrcSet={false}
        alt={article.image.altText || ''}
        width={article.image.width}
        height={article.image.height}
      />

      <div className={classNames('flex flex-col gap-2')}>
        <Typography
          className={classNames('text-greyscale-700')}
          tag={TypographyTag.p}
          variant={TypographyVariant.BodyRegular}>
          {renderDate(article.lastModifiedAt)}
        </Typography>
        <div className={classNames('text-ellipsis overflow-hidden')}>
          <Link
            to={article.url}
            title={`View ${article.title} MakerHub Article`}>
            <Typography
              className={classNames(styles.excert)}
              tag={TypographyTag.p}
              variant={TypographyVariant.BodyRegularBold}>
              {article.title}
            </Typography>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default MakerHubRelatedArticle
